export default "/images/szechenyi.webp?d4aa8ac5fc91f6b742bf15e4b60c5dd9";